/*
 * Kanful フローティングバナー
 * - <aside data-kf-fbanner-group> 配下の <a.kf-fbanner> を日時・優先度で選定
 * - スロット別 (upper/lower) に 1 件ずつ表示
 * - クローズボタンで sessionStorage フラグ、再読み込みで復活
 * - 1 分おきに再評価
 * - 設計書: docs/superpowers/specs/2026-04-17-floating-banner-design.md
 */
(function () {
  'use strict';

  const REEVAL_INTERVAL_MS = 60 * 1000;
  const PC_RIGHT_VAR = '--kf-fbanner-right';
  const BODY_PAD_VAR = '--kf-fbanner-body-pad';
  const MOBILE_BREAKPOINT = 750;

  function nowSec() {
    return Math.floor(Date.now() / 1000);
  }

  function isActive(banner, now) {
    const start = banner.dataset.startTs;
    const end = banner.dataset.endTs;
    if (start && now < parseInt(start, 10)) return false;
    if (end && now >= parseInt(end, 10)) return false;
    return true;
  }

  function pickWinners(banners, now) {
    const slots = { upper: [], middle: [], lower: [] };
    banners.forEach((b) => {
      if (!isActive(b, now)) return;
      const slot = b.dataset.slot;
      if (slot !== 'upper' && slot !== 'middle' && slot !== 'lower') return;
      slots[slot].push(b);
    });

    const winners = new Set();
    Object.values(slots).forEach((list) => {
      if (list.length === 0) return;
      list.sort((a, b) => {
        const pa = parseInt(a.dataset.priority || '0', 10);
        const pb = parseInt(b.dataset.priority || '0', 10);
        if (pa !== pb) return pb - pa;
        const pos = a.compareDocumentPosition(b);
        return pos & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
      });
      winners.add(list[0]);
    });

    return winners;
  }

  function applyVisibility(group, banners, winners) {
    let visibleCount = 0;
    banners.forEach((b) => {
      if (winners.has(b)) {
        b.hidden = false;
        visibleCount++;
      } else {
        b.hidden = true;
      }
    });
    group.hidden = visibleCount === 0;
  }

  function updateBodyPadding(group) {
    if (window.innerWidth >= MOBILE_BREAKPOINT) {
      document.body.style.setProperty(BODY_PAD_VAR, '0');
      return;
    }
    if (group.hidden) {
      document.body.style.setProperty(BODY_PAD_VAR, '0');
      return;
    }
    const h = group.offsetHeight;
    document.body.style.setProperty(BODY_PAD_VAR, `${h}px`);
  }

  function applyPcOffset(group) {
    const offset = parseInt(group.dataset.pcRight || '12', 10);
    group.style.setProperty(PC_RIGHT_VAR, `${offset}px`);
  }

  function init() {
    const group = document.querySelector('[data-kf-fbanner-group]');
    if (!group) return;

    applyPcOffset(group);

    const banners = Array.from(group.querySelectorAll('.kf-fbanner'));
    if (banners.length === 0) {
      group.hidden = true;
      return;
    }

    const evaluate = () => {
      const winners = pickWinners(banners, nowSec());
      applyVisibility(group, banners, winners);
      requestAnimationFrame(() => updateBodyPadding(group));
    };

    evaluate();
    setInterval(evaluate, REEVAL_INTERVAL_MS);
    window.addEventListener('resize', () => updateBodyPadding(group), { passive: true });

    const closeBtn = group.querySelector('[data-kf-fbanner-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        group.hidden = true;
        document.body.style.setProperty(BODY_PAD_VAR, '0');
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
